import styled from 'styled-components';
import Subtitle from '@components/Subtitle';

const StyledSubtitle = styled(Subtitle)`
  padding: ${({ theme }) => theme.spacing(10, 0, 0, 8)};
  margin: 0;
`;

export default StyledSubtitle;
